import { render } from "./KontextwechselModalUser.pug?vue&type=template&id=18905735&lang=pug"
import script from "./KontextwechselModalUser.js?vue&type=script&lang=js"
export * from "./KontextwechselModalUser.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__